import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class CfpProgramHdrQueryCriteriaClass extends BaseCriteriaModel {
  guids?: Optional<string[]> = Optional.empty();
  codes?: Optional<string[]> = Optional.empty();
  names?: Optional<string[]> = Optional.empty();
  search_word?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  updated_date_from?: Optional<string> = Optional.empty();
  updated_date_to?: Optional<string> = Optional.empty();
}

export class CfpProgramHdrCriteriaModelQuery {
  query = '';

  constructor(criteria: CfpProgramHdrQueryCriteriaClass) {
    if (!criteria) {
      return;
    }

    criteria.guids.ifPresent(arr => arr.forEach(x => this.query += '&guids=' + x));
    criteria.codes.ifPresent(arr => arr.forEach(x => this.query += '&codes=' + x));
    criteria.names.ifPresent(arr => arr.forEach(x => this.query += '&names=' + x));
    this.query += criteria.search_word.filter(x => x !== '').map(x => '&search_word=' + x).orElse('');
    this.query += criteria.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += criteria.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += criteria.updated_date_from.filter(x => x !== '').map(x => '&updated_date_from=' + x).orElse('');
    this.query += criteria.updated_date_to.filter(x => x !== '').map(x => '&updated_date_to=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;
  }
}
